module.exports = __webpack_public_path__ + "media/product.d06eb696.mp4";